import React from 'react';
import { InputItem } from 'antd-mobile';
import WrapComponent from './WrapComponent';

class PhoneNumber extends React.Component{
    render(){
        let {api_name, form, is_readonly, is_required, default_value, errorText} = this.props;
        const {getFieldProps} = form;
        let tempProps = {
            type: 'tel',
            name: api_name,
            disabled: is_readonly,
            placeholder: $st('请输入')
        }
        let fieldProps = getFieldProps(api_name, {
            initialValue: default_value,
            validate: [{
                trigger: 'onChange',
                rules: [{
                    required: is_required,
                    message: $st($st(`该项是必填项`))
                }],
            },{
                trigger: 'onChange',
                rules: [{
                    pattern: '^[0-9+-;(),]{0,100}$',
                    message: $st('手机号格式不正确')
                }]
            }]
        });
        
        return (
            <InputItem {...tempProps} {...fieldProps} >
                {errorText && <div className='input-error'>{errorText}</div>}
            </InputItem>
        )
    }
    
}
export default WrapComponent(PhoneNumber);


// WEBPACK FOOTER //
// ./src/component/PhoneNumber.js